export default __webpack_public_path__ + "fonts/CancerfondenSans-Bold.000652bf6129e74bd93e2960071608b4.woff";